import { useMemo } from 'react';

import { useRelationshipsContext } from '../providers/RelationshipsProvider';

/**
 * This hook allows getting relationship service data.
 * It must be used inside `RelationshipsProvider` component.
 *
 * The returned object is of shape:
 *   {
 *        data:[{
 *                  id: '123',
 *                  entities: [{
 *                    id: '456',
 *                    domain: 'autodesk-bim360-documentmanagement',
 *                    type: 'documentversion'
 *                  }, {
 *                    id: '789',
 *                    domain: 'autodesk-construction-sheet',
 *                    type: 'sheetversion'
 *                  }]
 *        }],
 *        error: undefined,
 *        loading: false
 *   }
 * @returns {{loading: *, error: *, data: *}}
 */

export default () => {
  const { relationshipDataBySource, relationshipsEntityMap } =
    useRelationshipsContext();
  return useMemo(() => {
    const results = [];
    let loading = false;
    let error = false;

    Object.keys(relationshipDataBySource).forEach((domain) => {
      Object.keys(relationshipDataBySource[domain]).forEach((type) => {
        Object.keys(relationshipDataBySource[domain][type]).forEach((id) => {
          const {
            relationshipsData,
            loading: isCurrentLoading,
            error: currentError,
          } = relationshipDataBySource[domain][type][id];
          if (relationshipsData && relationshipsData.length) {
            relationshipsData.forEach((relationship) => {
              results.push(relationshipsEntityMap[relationship.relationshipId]);
            });
          }
          if (isCurrentLoading) {
            loading = true;
          }
          if (currentError) {
            error = currentError;
          }
        });
      });
    });
    return {
      data: results,
      loading,
      error,
    };
  }, [relationshipDataBySource, relationshipsEntityMap]);
};
